import { Box, Button, Stack, Table, TableCell, TableContainer, TableRow, TextField, Typography, tableCellClasses } from "@mui/material"
import { ChangeEvent, useState } from "react"
import { login } from "../api/user"

export const LoginView = (props: {
    handleCancel: () => void,
    updateLocation: (result: {location: string, location_id: number}) => void
}) => {

    const {handleCancel, updateLocation} = props

    const [username, setUsername] = useState<string>("")
    const [password, setPassword] = useState<string>("")

    const handleOnChangeEmail = (event: ChangeEvent<HTMLInputElement>) => {
        setUsername(event.target.value);
    }

    const handleOnChangePassword = (event: ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    }

    const handleLogin = async () => {
        const result = await login(username.toLocaleLowerCase(), password);
        console.log(result);
        updateLocation(result);
        handleCancel();
    }

    const handleCancelLogin = () => {
        setUsername("");
        setPassword("");
        handleCancel();
    }

    return <>
    <Box sx={{
        backgroundColor: "#FFFFF9",
        width: "auto",
        height: "auto",
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "16px",
    }}>
        <Stack sx={{paddingLeft: "32px", paddingTop: "20px"}}>
                <Typography sx={{
                    fontSize: "32px",
                    fontWeight: "bold"
                }}> Login </Typography>
            </Stack>
        
        <TableContainer sx={{
            paddingTop: "16px"
        }}>
            <Table sx={{
                [`& .${tableCellClasses.root}`]: {
                    borderBottom: "none",
                    fontSize: "24px",
                    paddingTop: "0px",
                    paddingLeft: "16px",
                    },
            }}>
                <TableRow>
                    <TableCell>
                        <Typography>Email:</Typography>
                    </TableCell>
                    <TableCell>
                        <TextField value={username} onChange={handleOnChangeEmail} required/>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>
                        <Typography>Password:</Typography>
                    </TableCell>
                    <TableCell>
                        <TextField value={password} onChange={handleOnChangePassword} type="password" required/>
                    </TableCell>
                </TableRow>
            </Table>
        </TableContainer>
        <Stack direction={"row"} alignItems={"right"} justifyContent={"right"} sx={{
            paddingBottom: "32px"
        }}>
            <Button onClick={handleLogin} variant={"contained"}>Login</Button>
            <Button onClick={handleCancelLogin}>Cancel</Button>
        </Stack>
    </Box>
    
    </>
}